import { useAllCarts } from "@/api/cache/cartQueryOptions";

import { ButtonName, UserRetailerShoppingCart } from "@brandclub/common-ui";
import { Box, useTheme } from "@mui/material";
import React from "react";
import { formatMoney } from "../../utils/string";
import { ShopAppButton } from "./ShopAppButton";

export interface AddToBagButtonProps {
  disabled?: boolean;
  children?: React.ReactNode;

  onClick?: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    checkoutData: {
      allCarts: UserRetailerShoppingCart[];
      retailerIds: number[];
    }
  ) => void;
  price?: number;
}

const AddToBagButton: React.FC<AddToBagButtonProps> = ({
  disabled,
  onClick,
  price,
  children,
}) => {
  const theme = useTheme();
  const { data: allCarts } = useAllCarts({
    select: (data) => data.userRetailerShoppingCarts,
    // only read from cache to avoid resetting updated local carts
    enabled: false, // Prevents fetching
    staleTime: Infinity, // Prevents background refetches
  });
  const retailerIds = allCarts?.map((cart) => cart.retailerId);
  const content = theme.content?.addToBagButton?.signedOutDesktop;
  const buttonText = content?.text || "Add to bag";

  return (
    <>
      <ShopAppButton
        variant="solid"
        color="primary"
        buttonName={ButtonName.BagButton}
        disableMaxWidth
        disabled={disabled}
        onClick={(e) => {
          if (onClick && allCarts && retailerIds) {
            onClick(e, { allCarts, retailerIds });
          }
        }}
      >
        {children ? (
          children
        ) : (
          <>
            <Box
              component="span"
              sx={{
                whiteSpace: "nowrap",
              }}
            >
              {buttonText}
            </Box>
            <Box
              component="span"
              sx={(theme) => ({
                height: "6px",
                width: "6px",
                marginLeft: "6px",
                marginRight: "6px",
                borderRadius: "50%",
                backgroundColor: theme.vars.palette.primary.contrastText,
              })}
            />
            {!!price && <span>{formatMoney(price)}</span>}
          </>
        )}
      </ShopAppButton>
    </>
  );
};

export default AddToBagButton;
